module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "warp"
  }, [_c('el-col', {
    staticClass: "warp-breadcrum",
    attrs: {
      "span": 24
    }
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('b', [_vm._v("首页")])]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("保障人员")])], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "warp-main",
    attrs: {
      "span": 24,
      "element-loading-text": "拼命加载中"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "min-width": "240px"
    },
    attrs: {
      "placeholder": "姓名"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch($event)
      }
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddDialog
    }
  }, [_vm._v("添加")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.users,
      "highlight-current-row": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60",
      "fixed": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "120",
      "fixed": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "手机号",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "label": "类型",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sexName",
      "label": "性别",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "certTypeName",
      "label": "证件类型",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "certNo",
      "label": "证件号码",
      "width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "邮箱",
      "min-width": "160",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "birth",
      "label": "出生日期",
      "min-width": "160",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "户口地",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "liveAddress",
      "label": "居住地",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "statusName",
      "label": "状态",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.showEditDialog(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeUser(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.bingProject(scope.$index, scope.row)
            }
          }
        }, [_vm._v("项目")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "page-sizes": [10, 20, 50, 100],
      "page-size": 10,
      "background": "",
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.form.title,
      "visible": _vm.form.visible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.form, "visible", $event)
      }
    }
  }, [_c('el-form', {
    ref: "formref",
    attrs: {
      "model": _vm.form.data,
      "label-width": "80px",
      "rules": _vm.form.rules
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.data.name),
      callback: function($$v) {
        _vm.$set(_vm.form.data, "name", $$v)
      },
      expression: "form.data.name"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "所属机构"
    }
  }, [_c('TreeSelect', {
    ref: "addtreeSelect",
    attrs: {
      "props": _vm.form.props,
      "options": _vm.form.orgs,
      "value": _vm.form.valueId,
      "clearable": _vm.form.isClearable,
      "accordion": _vm.form.isAccordion
    },
    on: {
      "getValue": function($event) {
        return _vm.getValue($event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    attrs: {
      "label": "人员类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.data.type),
      callback: function($$v) {
        _vm.$set(_vm.form.data, "type", $$v)
      },
      expression: "form.data.type"
    }
  }, _vm._l((_vm.form.dicSafeUserType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "label": "用户状态",
      "prop": "status"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.data.status),
      callback: function($$v) {
        _vm.$set(_vm.form.data, "status", $$v)
      },
      expression: "form.data.status"
    }
  }, _vm._l((_vm.form.dictStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "性别",
      "prop": "sex"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.data.sex),
      callback: function($$v) {
        _vm.$set(_vm.form.data, "sex", $$v)
      },
      expression: "form.data.sex"
    }
  }, _vm._l((_vm.form.dictSex), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "出生日期",
      "prop": "birth"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "出生日期"
    },
    model: {
      value: (_vm.form.data.birth),
      callback: function($$v) {
        _vm.$set(_vm.form.data, "birth", $$v)
      },
      expression: "form.data.birth"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "证件类型",
      "prop": "certType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.data.certType),
      callback: function($$v) {
        _vm.$set(_vm.form.data, "certType", $$v)
      },
      expression: "form.data.certType"
    }
  }, _vm._l((_vm.form.dictCertType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "证件号码",
      "prop": "certNo"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.data.certNo),
      callback: function($$v) {
        _vm.$set(_vm.form.data, "certNo", $$v)
      },
      expression: "form.data.certNo"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "手机号",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.data.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form.data, "mobile", $$v)
      },
      expression: "form.data.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.data.email),
      callback: function($$v) {
        _vm.$set(_vm.form.data, "email", $$v)
      },
      expression: "form.data.email"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "户口地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.data.address),
      callback: function($$v) {
        _vm.$set(_vm.form.data, "address", $$v)
      },
      expression: "form.data.address"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "居住地址",
      "prop": "liveAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.data.liveAddress),
      callback: function($$v) {
        _vm.$set(_vm.form.data, "liveAddress", $$v)
      },
      expression: "form.data.liveAddress"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.form.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.form.submit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "项目绑定",
      "visible": _vm.project.visible,
      "close-on-click-modal": false,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.project, "visible", $event)
      },
      "opened": _vm.myopened
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.project.filter
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "min-width": "240px"
    },
    attrs: {
      "placeholder": "项目名称"
    },
    model: {
      value: (_vm.project.filter.projectName),
      callback: function($$v) {
        _vm.$set(_vm.project.filter, "projectName", $$v)
      },
      expression: "project.filter.projectName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.projectSearch
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.project.data,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.prjectHandleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "项目名",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "custName",
      "label": "企业",
      "width": "320"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "provinceName",
      "label": "省",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "label": "市",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "districtName",
      "label": "区/县",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addressDetail",
      "label": "地址"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "page-sizes": [10, 20, 50, 100],
      "current-page": _vm.project.current,
      "page-size": 10,
      "background": "",
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.project.total
    },
    on: {
      "size-change": _vm.projectHandleSizeChange,
      "current-change": _vm.projectHandleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.project, "current", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.project, "current", $event)
      }
    }
  }), _vm._v(" "), _c('br')]], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72afae40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/safeuser/list.vue
// module id = 1181
// module chunks = 2